import { TagProps as AntdTagProps } from 'antd';
import { StyledTag } from './TagStyles';

export type TagProps = AntdTagProps;

const Tag = (props: TagProps) => <StyledTag {...props} />;

export default Tag;
